module.exports = __webpack_public_path__ + "img/map_1.a0a5c690.jpg";